import script from "./org-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./org-list.vue?vue&type=script&lang=ts&setup=true"

import "./org-list.vue?vue&type=style&index=0&id=2737107a&lang=less&scoped=true"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2737107a"]])

export default __exports__